<template>
  <transition
    v-if="mode === 'normal'"
    :name="type"
    mode="out-in"
    :enter-active-class="type+'In'"
    :leave-active-class="type+'Out'"
    v-bind="$attrs"
    v-on="hooks"
  >
      <slot></slot>
  </transition>
  <transition-group
    v-else-if="mode === 'group'"
    :name="type"
    mode="out-in"
    :enter-active-class="type+'In'"
    :leave-active-class="type+'Out'"
    v-bind="$attrs"
    v-on="hooks"
  >
      <slot></slot>
  </transition-group>
</template>
<script>
export default {
  name: 'VpTransition',
  props: {
    type: {
      type: String,
      required: true,
      validator(value) {
        return ['fade'].indexOf(value) !== -1;
      },
    },
    duration: {
      type: Number,
      default: 300,
    },
    mode: {
      type: String,
      default: 'normal',
    },
  },
  computed: {
    hooks() {
      return {
        beforeEnter: this.setDuration,
        afterEnter: this.cleanUpDuration,
        beforeLeave: this.setDuration,
        afterLeave: this.cleanUpDuration,
        ...this.$listeners,
      };
    },
  },
  methods: {
    setDuration(el) {
      el.style.animationDuration = `${this.duration}ms`;
    },
    cleanUpDuration(el) {
      el.style.animationDuration = '';
    },
  },
};
</script>
<style>
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.fadeIn {
  animation-name: fadeIn;
}
@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
.fadeOut {
  animation-name: fadeOut;
}
</style>
